<div class="img-container">
  @for (audio of audioData; track audio) {
    <div class="brdr audio-container">
      <img src="{{audio.imgSouce}}">
    </div>
  }
</div>